import { useEffect } from 'react';

// Tells index.html's boot-error handler the app arrived: errors after this are
// runtime problems for Sentry, not a failed load the shell should announce.
// An effect, not a statement after render() - render only schedules the first
// commit, and a crash inside it must leave the flag unset so the shell speaks.
export default function MarkBooted() {
  useEffect(() => {
    (window as Window & { __onsiteBooted?: boolean }).__onsiteBooted = true;
  }, []);
  return null;
}
